import { createContext } from 'react';
import { useSteps } from './useSteps';
export { MEETING_ASIDE_KEY, MEETING_ASIDE_SLUG, SUCCESS_STEP_KEY, SUCCESS_STEP_SLUG } from './stepKeys';
export const StepsContext = createContext<ReturnType<typeof useSteps> | null>(null);
type StepsProviderProps = {
  children: React.ReactNode;
  initialStep?: string;
};
export function StepsProvider({
  children,
  initialStep
}: StepsProviderProps) {
  const steps = useSteps({
    initialStep
  });
  return <StepsContext.Provider value={steps}>{children}</StepsContext.Provider>;
}